<template>
  <div class="about">
    <Header/>
     <div class="body">
       <div class="sobre">
           <transition name="bounce">
             <h2 v-if="show" class="msgs">Conheça nosso espaço</h2>
           </transition><br>
           <div id="localizacao">
             <div class="texto_espaco">
                 <p class="p_sobre">O Cursinho Sapiência conta com uma estrutura que satisfaz suas necessidades, ambientes climatizados e espaçosos, para você assistir aula e fazer seus estudos extras; micro-ondas e geladeiras, possibilitando que você traga sua refeição para lanchar e almoçar durante os intervalos das aulas; livros disponíveis para empréstimo, os quais irão enriquecer a sua bibliografia complementar. Ou seja, todo o suporte que você precisa para focar nos seus estudos. </p>
             </div>
             <!-- <div class="texto_espaco">
                 <p class="p_sobre">Disponibilizamos tudo o que você precisa para ter o rendimento que
                 você quer: temos uma biblioteca cheia de livros de teoria, de filosofia
                 e de literatura (incluindo todos os livros das listas obrigatórias do seu vestibular).</p>
             </div> -->
           </div>
          <h5>Nosso espaço de estudos é aconchegante e organizado!</h5><br>

        <carousel
          id="material_carousel"
         :items="1"
         :nav="false"
         :center="true"
         >
            <div class="item">
             <div id="localizacao">
               <div class="img_location">
                 <img alt="aprovados" id="img_turma" src="../assets/galeria/espaco1.jpg">
                 <br>
               </div>
             </div>
            </div>
            <div class="item">
              <div id="localizacao">
                <div class="img_location">
                  <img alt="aprovados" id="img_turma" src="../assets/galeria/espaco2.jpg">
                  <br>
                </div>
              </div>
            </div>
            <div class="item">
              <div id="localizacao">
                <div class="img_location">
                  <img alt="aprovados" id="img_turma" src="../assets/galeria/espaco3.jpg">
                </div>
              </div>
            </div>
            <div class="item">
              <div id="localizacao">
                <div class="img_location">
                  <img alt="aprovados" id="img_turma" src="../assets/galeria/espaco5.jpeg">
                  <br>
                </div>
              </div>
            </div>
            <div class="item">
              <div id="localizacao">
                <div class="img_location">
                  <img alt="aprovados" id="img_turma" src="../assets/galeria/espaco4.jpeg">
                  <br>
                </div>
              </div>
            </div>
        </carousel>
      </div>
    </div>
  <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import carousel from 'vue-owl-carousel'

export default{
  mounted() {
    this.change();
  },
  components:{
    Header,
    Footer,
    carousel
  },
  data (){
    return{
      show: false
    }
  },
  methods:{
    change(){
      this.show=true
    }
  }
}
</script>

<style>
 @import "../assets/style_padrao.css";
  h5 {
    text-align: center;
    color: #4F4F4F;
  }
  .bounce-enter-active {
  animation: bounce-in .5s;
  }
  .bounce-leave-active {
  animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
  }
  #ver_mais{
    color:purple;
  }
  #img_turma {
    margin:0 auto;
  }
</style>
